export default __webpack_public_path__ + "static/media/mfa-deactivate.790194dc.svg";